import React, { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "@/Components/Common/BreadCrumb";
import DraggableTable, { DraggableTableColumn } from "@/Components/Common/DraggableTable";
import { Button, Modal, ModalBody } from "@/Components/ui";
import { API, BACKEND_HOST } from "@/api";
import { dialogService } from "@/utils/dialogService";
type TicketProductRow = {
    id: number;
    상품명: string;
    가격: number | string;
    상태: string;
    재고: string;
    remaining_stock: number | string;
};
export default function TicketProducts() {
    const navigate = useNavigate();
    const [data, setData] = useState<TicketProductRow[]>([]);
    const [delRecord, setDelRecord] = useState<number | null>(null);
    const [modalDelete, setModalDelete] = useState(false);
    const fetchProducts = useCallback(async () => {
        try {
            const res = await API.get(`${BACKEND_HOST}/ticket/products/?include_hidden=true`);
            setData(res.data || []);
        }
        catch (error) {
            console.error(error);
        }
    }, []);
    React.useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);
    const handleEdit = useCallback((id: number) => {
        navigate(`/ticket-product-form/${id}`);
    }, [navigate]);
    const handleCopy = useCallback((id: number) => {
        navigate(`/ticket-product-form/${id}?copy=true`);
    }, [navigate]);
    const handleDelete = useCallback((id: number) => {
        setDelRecord(id);
        setModalDelete(true);
    }, []);
    const deleteRecord = useCallback(async () => {
        if (!delRecord)
            return;
        try {
            await API.delete(`${BACKEND_HOST}/ticket/products/${delRecord}/`);
            setModalDelete(false);
            setDelRecord(null);
            await fetchProducts();
            await dialogService.handleAlert("Delete ok!");
        }
        catch (error: any) {
            await dialogService.handleAlert(error?.message ?? "Delete failed", { force: "error" });
        }
    }, [delRecord, fetchProducts]);
    const handleSaveOrder = useCallback(async (rows: TicketProductRow[]) => {
        try {
            await API.post(`${BACKEND_HOST}/ticket/products/reorder/`, {
                ids: rows.map((row) => row.id),
            });
            await fetchProducts();
        }
        catch (error) {
            await fetchProducts();
            throw error;
        }
    }, [fetchProducts]);
    const columns = useMemo<DraggableTableColumn<TicketProductRow>[]>(() => [
        { key: "id", header: "ID", render: (row) => row.id },
        { key: "name", header: "상품명", render: (row) => row.상품명 },
        { key: "price", header: "가격", render: (row) => row.가격 },
        { key: "state", header: "상태", render: (row) => row.상태 },
        { key: "stock", header: "재고", render: (row) => row.재고 },
        { key: "remaining", header: "remaining_stock", render: (row) => row.remaining_stock },
        {
            key: "actions",
            header: "관리",
            className: "whitespace-nowrap",
            render: (row) => (<div className="flex gap-2">
            <Button onClick={() => handleEdit(row.id)} color="success" size="sm" className="edit-item-btn">
              수정
            </Button>
            <Button onClick={() => handleCopy(row.id)} color="info" size="sm" className="copy-item-btn">
              복사
            </Button>
            <Button onClick={() => handleDelete(row.id)} color="danger" size="sm" className="remove-item-btn">
              삭제
            </Button>
          </div>),
        },
    ], [handleCopy, handleDelete, handleEdit]);
    return (<React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb title="티켓상품" pageTitle="티켓"/>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full px-3">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title mb-0 flex-grow-1">티켓상품 목록</h4>
                  <div>
                    <Button onClick={() => {
            navigate("/ticket-product-form/0");
        }} id="create-btn" color="success" className="add-btn me-1">
                      <i className="ri-add-line align-bottom me-1"></i> 생성
                    </Button>
                  </div>
                </div>
                <div className="card-body">
                  <DraggableTable data={data} getRowId={(row) => row.id} columns={columns} onReorder={setData} onSaveOrder={handleSaveOrder} onSaveError={async (error: any) => {
            await dialogService.handleAlert(error?.response?.data?.error || error?.message || "순서 저장에 실패했습니다.");
        }} emptyText="티켓 상품이 없습니다."/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modalDelete} onClose={() => setModalDelete(false)} variant="dialog">
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h4 className="mb-3">Are you Sure ?</h4>
            <p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
            <div className="hstack gap-2 justify-content-center">
              <Button onClick={() => {
            setDelRecord(null);
            setModalDelete(false);
        }} color="light">
                Cancel
              </Button>
              <Button onClick={deleteRecord} color="danger">
                Delete
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>);
}
